import * as React from "react";
import { useAppSelector } from "../../../../store/hooks";
import { selectOrg } from "../../../../store/contextSlice";
import { selectOrgs } from "../../../../store/userDataSlice";
import { parseTagColumnsConfig, TAG_COLUMNS_ORG_TAG_KEY } from "./parseTagColumnsConfig";
import { TagValueColumn } from "./tagValueColumn";
import { TableColumn } from "../../types";

export function useTagColumns<TData extends { tags?: Record<string, any> }>(resourceType: string): TableColumn<TData>[] {
  const org = useAppSelector(selectOrg);
  const orgs = useAppSelector(selectOrgs);
  const currentOrg = orgs.find((o) => o.name === org);

  const tagColumnsConfigValue = currentOrg?.tags?.[TAG_COLUMNS_ORG_TAG_KEY];

  return React.useMemo(() => {
    const config = parseTagColumnsConfig(tagColumnsConfigValue);
    const tagNames = config[resourceType];
    if (!tagNames || tagNames.length === 0) {
      return [];
    }
    return tagNames.map((tagKey) => TagValueColumn<TData>(tagKey));
  }, [tagColumnsConfigValue, resourceType]);
}
